import createVueComponent from '../createVueComponent';

const RotateCcw = createVueComponent('RotateCcwIcon', [
  ['path', { d: 'M3 2v6h6' }],
  ['path', { d: 'M3 13a9 9 0 103-7.7L3 8' }],
]);

export default RotateCcw;
